import React from 'react';

const LazyRodeoEventLeaderBoard = React.lazy(() =>
    import('./players')
);

const OverUnderEventLeaderBoard = (props: Record<string, any>) => (
    <React.Suspense fallback={<h1>Loading...</h1>}>
        <LazyRodeoEventLeaderBoard {...props} />
    </React.Suspense>
);

export default OverUnderEventLeaderBoard